import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ToastService } from '../../services/toast.service';
import { SuperAdminService } from '@core/services/super-admin.service';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-reset-password-confirmation',
  templateUrl: './reset-password-confirmation.component.html',
  styleUrls: ['./reset-password-confirmation.component.scss']
})
export class ResetPasswordConfirmationComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  bodyText: string = '';
  headerText = '';
  id ='';
  userRoles = USER_ROLES;
  constructor(
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    private readonly toastService: ToastService, 
    private readonly superAdminService: SuperAdminService) { }

  ngOnInit(): void {
    this.bodyText = this.config.data?.bodyText;
    this.headerText = this.config?.data?.headerText;
    this.id = this.config?.data?.id
  }

  checkUser(){
    const request = {
      userId: this.id,
    }
    if(this.config.data.user === this.userRoles.GROUP_USER){
      this.resetDispatcherUser(request)
    }else{
      this.resetDriverUser(request);
    }
  }

  continue(): void {
    this.checkUser()
  }
  
  resetDriverUser(request){
    this.superAdminService.resetPassword(request)
    .pipe(
      autoUnsubWith(this.destroyRef)
    ) 
    .subscribe({
      next: (_resposne) => {
        
        this.ref.close();
        this.toastService.showToastMessage('success', 'Success', 'Password reset successfully')
      },
      error: (error) => { 
        this.ref.close();
        this.toastService.showToastMessage('error', 'Error', error.error?.message)
      }
  
    })

  }

  resetDispatcherUser(request){
    this.superAdminService.resetPassword(request)
    .pipe(
      autoUnsubWith(this.destroyRef)
    )
    .subscribe({
      next: (_resposne) => {
        
        this.ref.close();
        this.toastService.showToastMessage('success', 'Success', 'Password reset successfully')
      },
      error: (error) => {
        this.ref.close();
        this.toastService.showToastMessage('error', 'Error', error.error?.message)
      }

    })
  }

  deactivateAccount() {
    this.ref.close();
  }
}